// Get PowerBi Reports for insight
import {stableGetRequest} from '../requests/stableGetRequest.js'
import CryptoJS from "crypto-js";
import handlePowerBiAuth from "./handlePowerBiAuth";
export default async function handlePowerBiInsights(workspace_id, token) {
  var header = {
    method: "GET",
    headers: {
      Authorization: token,
    },
  };

  // Fetch Current Access Token
  var token = await handlePowerBiAuth(token)

  // FETCH - EMBEDDED INFO
  if(workspace_id !== null && workspace_id !== undefined && workspace_id !== '') {
    let url = process.env.REACT_APP_POWERBI_API+`powerbi-insights?workspace_id=${workspace_id}&access_token=${token.access_token}`
    let newData = await stableGetRequest(url,header)
    localStorage.setItem(
      "powerBiInsights",
      CryptoJS.AES.encrypt(
        JSON.stringify(newData),
        process.env.REACT_APP_PASS
      ).toString()
    );
    console.log("GOT INSIGHTS", newData)
  }
  else {
    console.log("PROBLEM WITH INSIGHT")
  }
}



// WEBPACK FOOTER //
// ./src/util/powerBi/handlePowerBiInsights.jsx